import FormKyc from './FormKyc/FormKyc'
export const FormKycPageAraucoMalls = FormKyc